import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TotalAvailableBalanceSection from "../Components/dashboard-sections/TotalAvailableBalanceSection";
import QuickActionSection from "../Components/dashboard-sections/QuickActionSection";
import SectionNameSection from "../Components/dashboard-sections/SectionNameSection";
import TransactionHistorySection from "../Components/dashboard-sections/TransactionHistorySection";
import MainLayout from "../layout/MainLayout";
import { ToggleButton, QuickActionSelect } from "../Components";

const Dashboard = () => {
  const navigate = useNavigate();
  const options = ["Account overview", "Reporting dashboard"];
  const [activeView, setActiveView] = useState("Account overview");

  const handleViewChange = (value) => {
    setActiveView(value);
    if (value === "Reporting dashboard") {
      navigate("/reports");
    }
  };

  const navbarContent = (
    <>
      <ToggleButton
        options={options}
        defaultValue={activeView}
        onChange={handleViewChange}
      />
      <QuickActionSelect />
    </>
  );

  return (
    <MainLayout
      NavName="Dashboard"
      navbarChildren={navbarContent}
      pageClassName="dashboard-page"
      contentClassName="dashboard-content"
    >
      <div className="dashboard-shell">
        {/* Total Available Balance */}
        <TotalAvailableBalanceSection />

        <div className="row g-3 dashboard-actions-row">
          {/* Quick Action */}
          <div className="col-lg-6 col-md-12">
            <div className="dashboard-panel">
              <QuickActionSection />
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            {/* Section Name */}
            <div className="dashboard-panel">
              <SectionNameSection />
            </div>
          </div>
        </div>

        {/* Transaction History */}
        <div className="dashboard-panel mt-4">
          <TransactionHistorySection />
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
